export default "__VITE_ASSET__DUgy2W4F__"